import { WorkerEmploymentType } from '@types';

type GetFlexWorkerLabelParams = {
  employmentType?: WorkerEmploymentType | null;
  hasCandidateLevel?: boolean;
  isReplacement?: boolean;
  lenderCompanyName?: string | null;
};

export const getFlexWorkerLabel = ({
  employmentType,
  hasCandidateLevel,
  isReplacement,
  lenderCompanyName,
}: GetFlexWorkerLabelParams) => {
  if (hasCandidateLevel) {
    return 'Candidate';
  }

  if (isReplacement) {
    return 'Vervanger';
  }

  if (employmentType === 'FREELANCER') {
    return 'Zelfstandige';
  }

  if (employmentType === 'TEMPWORKER') {
    return 'Uitzendkracht';
  }

  if (employmentType === 'EMPLOYEE') {
    return lenderCompanyName ? `Werknemer - ${lenderCompanyName}` : 'Werknemer';
  }

  return undefined;
};
